<template>
    <div id="login-page">
        <b-row>
            <b-col lg="8" class="bg-login-color">
                <div class="center-layout">
                    <b-row class="card p-5">
                        <b-col md="12">
                            <form v-on:submit.prevent="onSubmit">
                                <h2>Login To ERP</h2>
                                <b-alert variant="danger" :show="errorMsg !== null">
                                    <span v-html="errorMsg"></span>
                                </b-alert>
                                <div class="form-group mt-4">
                                    <b-form-input type="text" v-model="model.username" class="form-control" placeholder="Staff ID" id="exampleInputUsername" aria-describedby="emailHelp"
                                    name="username"
                                    autofocus
                                    v-bind:class="errors.has('username') ? 'is-invalid':''" v-validate="'required'" />
                                </div>
                                <div class="form-group mt-4">
                                    <b-input-group class="mb-2">
                                        <input :type="passwordFieldType" v-model="model.password" class="form-control" placeholder="Password" id="exampleInputPassword" aria-describedby="emailHelp" name="password" autofocus v-bind:class="errors.has('password') ? 'is-invalid':''" v-validate="'required'" />
                                        <b-input-group-prepend v-if="passwordFieldType === 'password'" is-text>
                                            <b-icon icon="eye-fill" type="password" @click="switchVisibility"></b-icon>
                                        </b-input-group-prepend>
                                        <b-input-group-prepend v-else is-text>
                                            <b-icon icon="eye-slash-fill" type="password" @click="switchVisibility"></b-icon>
                                        </b-input-group-prepend>
                                    </b-input-group>
                                </div>
                                <div class="form-group mt-4">
                                    <b-button type="submit" class="text-white" variant="primary" block :disabled="isLoading">
                                       <font-awesome-icon v-if="isLoading" icon="spinner" spin></font-awesome-icon> Login
                                    </b-button>
                                </div>
                                <div class="form-group mt-4 text-right">
                                    <b-button variant="link"><strong>Forgot Password</strong></b-button>
                                </div>
                            </form>
                        </b-col>
                    </b-row>
                </div>
            </b-col>
            <b-col lg="4" class="p-0 d-none d-lg-block">
                <div class="bg-side">
                    <div class="tagline">
                        <h3>Welcome To ERP System</h3>
                        <h5>Make Your Work Easier and Fun</h5>
                    </div>
                </div>
            </b-col>
        </b-row>
    </div>
</template>
<script>
export default {
    data () {
        return {
            errorMsg: null,
            isLoading: false,
            model: {
                username: '',
                password: ''
            },
            passwordFieldType: 'password'
        }
    },
    // watch: {
    //     'errorMsg' (value) {
    //         if (value !== null) {
    //             setTimeout(() => {
    //                 this.errorMsg = null
    //             }, 3000)
    //         }
    //     }
    // },
    methods: {
        switchVisibility() {
            this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password'
        },
        onSubmit () {
            if (this.isLoading) {
                return false
            }
            this.$validator.validateAll().then(res => {
                this.$notifications.clear()
                if (res) {
                    this.isLoading = true
                    this.$store.dispatch('account/login', {
                        username: this.model.username,
                        password: this.model.password
                    }).then(() => {
                        this.$store.dispatch('notification/welcome', this.$store.getters['account/accountData'].firstName)
                        this.isLoading = false
                        if (this.$route.query.redirect !== undefined) {
                            this.$router.push(this.$route.query.redirect)
                        } else if (this.$store.getters['account/accountData'].role === 'Transportation' || this.$store.getters['account/accountData'].role === 'Driver') {
                            this.$router.push('/vehicle')
                        } else {
                            this.$router.push('/dashboard')
                        }
                    }).catch((error) => {
                        this.isLoading = false
                        this.errorMsg = window.serializeErrorMessage(error)
                    })
                } else {
                    this.errorMsg = 'Username and password can\'t be empty'
                }
            })
        }
    },
}
</script>
<style lang="css" scoped>
    .card {
        border-width: 0px;
        box-shadow: 0px 0px 21px -6px #000 !important;
    }
</style>